import {ResearchLitElement, html, css} from '@core/research-lit-element';

export class ResearchFilterSkeleton extends ResearchLitElement {
    static get is() {
        return 'research-filter-skeleton';
    }
    static get styles() {
        return css`
            :host {
                display: flex;
                flex-direction: column;
                width: 100%;
                --opacity: 0.1;
                background-color: var(--color-invert-background-solid-10);
            }

            .container {
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                width: 100%;
                height: 306px;
                border-radius: var(--border-radius-31);
                padding: var(--space-16);
                box-sizing: border-box;
                border: 1px solid var(--color-invert-component-tr-10);
                background-color: var(--color-invert-component-tr-80);
            }

            .title {
                height: 35px;
                width: 80%;
                background-color: var(--color-invert-component-tr-70);
                border-radius: var(--border-radius-31);
            }

            .item {
                height: 20px;
                background-color: var(--color-invert-component-tr-70);
                border-radius: var(--border-radius-31);
            }
        `;
    }

    render() {
        return html`
            <div class="container">
                <div class="title"></div>
                <div class="item" style="width: 70%"></div>
                <div class="item" style="width: 70%"></div>
                <div class="item" style="width: 70%"></div>
                <div class="item" style="width: 70%"></div>
                <div class="item" style="width: 70%"></div>
                <div class="item" style="width: 70%"></div>
            </div>
        `;
    }
}
customElements.define(ResearchFilterSkeleton.is, ResearchFilterSkeleton);
